import { installClerkInterceptors } from "./clerk-interceptors";
import { useGeneralStore } from "@/store/general/general.store";
import { useTenantStore } from "@/store/tenant/tenant.store";
import { ExibraHeaders } from "@exibra/shared";
import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";

export class ApiService {
    /**
     * The api base
     */
    protected readonly apiBase = import.meta.env.VITE_API_URL;

    /**
     * Axios instance configured for the eco api
     */
    public axios: AxiosInstance;

    constructor() {
        this.axios = axios.create({
            baseURL: this.apiBase,
        });

        this.axios.interceptors.request.use(
            (config: InternalAxiosRequestConfig) => {
                useGeneralStore.getState().openAsyncOperation(config.url ?? "");

                const tenantId = useTenantStore.getState().selectedTenant?.id;
                if (tenantId) {
                    config.headers[ExibraHeaders.TenantId] = tenantId;
                }

                return config;
            },
            (error) => {
                this.handleFinalizedRequest(error?.config?.url ?? "");
                return Promise.reject(error);
            },
        );

        this.axios.interceptors.response.use(
            (response) => {
                this.handleFinalizedRequest(response.config.url ?? "");
                return response;
            },
            (error) => {
                this.handleFinalizedRequest(error?.config?.url ?? "");

                return Promise.reject(error);
            },
        );
        installClerkInterceptors(this.axios);
    }

    /**
     * Handles a finalized request
     */
    private handleFinalizedRequest(id: string) {
        useGeneralStore.getState().closeAsyncOperation(id);
    }
}

// export const apiService = new ApiService();
